import React from "react";
import { FormInstance, Spin } from "antd";
import BaseForm from "./Form/BaseForm";
import { ColConfig, FormFieldConfig } from "../helpers/shared-interfaces";

export const TRUSTEE_FORM_FIELD_NAMES = [
  "name",
  "postalAddress",
  "streetName",
  "location",
];

const FULL_WIDTH_COLUMNS: ColConfig[] = [
  { span: 24 },
  { span: 24 },
  { span: 24 },
  { span: 24 },
];

export const PAGE_COLUMNS: ColConfig[] = [
  { span: 11 },
  { span: 11, offset: 1 },
  { span: 11 },
  { span: 11, offset: 1 },
];

export const trusteeFormFields = (
  columns: ColConfig[] = FULL_WIDTH_COLUMNS,
): FormFieldConfig[] => [
  {
    name: "name",
    label: "Name",
    inputType: "string",
    placeholder: "Enter trustee name",
    rule: "string",
    required: true,
    colConfig: columns[0],
  },
  {
    name: "postalAddress",
    label: "Postal Address",
    inputType: "string",
    placeholder: "Enter postal address",
    rule: "string",
    required: false,
    colConfig: columns[1],
  },
  {
    name: "streetName",
    label: "Street Name",
    inputType: "string",
    placeholder: "Enter street name",
    rule: "string",
    required: false,
    colConfig: columns[2],
  },
  {
    name: "location",
    label: "Location",
    inputType: "string",
    placeholder: "Enter location",
    rule: "string",
    required: false,
    colConfig: columns[3],
  },
];

const TrusteeForm = (props: {
  reference: React.RefObject<FormInstance>;
  isLoading: boolean;
}): JSX.Element => (
  <Spin spinning={props.isLoading}>
    <BaseForm
      layout="vertical"
      reference={props.reference}
      fieldsToHide={[]}
      fields={trusteeFormFields()}
    />
  </Spin>
);

export default TrusteeForm;
